import React, { useEffect, useRef, useState } from 'react';

const SCRIPT_ID = 'calendly-widget-script';

export default function CalendlyInline({ url, className = '' }) {
  const ref = useRef(null);
  const wrapRef = useRef(null);
  // Only load the (very heavy) Calendly bundle once the widget is close to view.
  const [active, setActive] = useState(false);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el || active) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setActive(true);
          io.disconnect();
        }
      },
      { rootMargin: '300px' }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [active]);

  useEffect(() => {
    if (!active) return;
    let cancelled = false;

    const init = () => {
      if (cancelled || !ref.current || !window.Calendly) return;
      ref.current.innerHTML = '';
      window.Calendly.initInlineWidget({ url, parentElement: ref.current });
    };

    if (window.Calendly) {
      init();
      return () => { cancelled = true; };
    }

    let s = document.getElementById(SCRIPT_ID);
    if (!s) {
      s = document.createElement('script');
      s.id = SCRIPT_ID;
      s.src = 'https://assets.calendly.com/assets/external/widget.js';
      s.async = true;
      document.body.appendChild(s);
    }
    s.addEventListener('load', init);
    return () => {
      cancelled = true;
      s.removeEventListener('load', init);
    };
  }, [url, active]);

  return (
    <div ref={wrapRef} className={className} style={{ minWidth: '280px' }}>
      <div ref={ref} className="w-full h-full" />
    </div>
  );
}